import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "@posthog/react";

const PostHogPageView = () => {
    const posthog = usePostHog();
    const location = useLocation();
    const hasCapturedInitialView = useRef(false);

    useEffect(() => {
        // On first mount, and on every route change, record a pageview.
        // SPA route changes don't reliably trigger PostHog's built-in pageview capture.
        if (!posthog) return;

        // Some extensions/adblockers can block PostHog; this keeps our code resilient.
        try {
            posthog.capture("$pageview", {
                $current_url: window.location.href,
                path: location.pathname,
                search: location.search,
            });

            if (process.env.NODE_ENV === "development" && !hasCapturedInitialView.current) {
                hasCapturedInitialView.current = true;
                posthog.capture("debug_app_loaded", {
                    $current_url: window.location.href,
                });
            }
        } catch {
            // no-op
        }
    }, [posthog, location.pathname, location.search]);

    return null;
};

export default PostHogPageView;
